<section style="overflow: auto !important; height: auto !important">
  <div class="period-toolbar">
    <div class="toolbar-left">
      <div
        class="user-select"
        *appVisibleOnly="['update_all_users_availability']"
      >
        <p-select
          [hidden]="!userResources"
          [options]="userResources || []"
          [(ngModel)]="selectedUser"
          [optionLabel]="'title'"
          (onChange)="resourceFilterChange($event, 'USERS')"
          data-cy="user-resource"
        ></p-select>
      </div>

      @if (presenceBooking) {
        <button
          pButton
          type="button"
          class="p-button-outlined p-button-sm"
          (click)="returnToSchedule()"
          data-cy="back-to-schedule"
        >
          &larr; {{ 'availability.back-to-schedule' | translate }}
        </button>
      }
    </div>

    <div class="toolbar-right">
      <button
        pButton
        type="button"
        class="p-button-sm"
        icon="pi pi-plus"
        (click)="openBulkDialog('range')"
        data-cy="add-period"
      >
        {{ 'appointment-period.add-period' | translate }}
      </button>
    </div>
  </div>

  <full-calendar
    #appointmentPeriodProfile
    [options]="calendarOptions"
  ></full-calendar>
</section>
